// Kartenzahlungs-Metadaten aus dem Bank-Zahlungstext (Spiegel von services/bank_match_service.parse_card_meta)
export function parseCardMeta(text) {
  const out = { purchaseDate: null, feePct: null, cardLast4: null };
  if (!text) return out;
  const d = /\bVOM\s+(\d{1,2})\.(\d{1,2})\.(\d{4})/i.exec(text);
  if (d) out.purchaseDate = `${d[3]}-${d[2].padStart(2, "0")}-${d[1].padStart(2, "0")}`;
  const p = /(\d+(?:[.,]\d+)?)\s*%/.exec(text);
  if (p && d) out.feePct = parseFloat(p[1].replace(",", "."));
  const c = /KARTEN?\s*(?:NR|NUMMER)\.?\s*[X*\s]*(\d{4})/i.exec(text);
  if (c) out.cardLast4 = c[1];
  return out;
}

export const PAID_SOURCE_LABEL = {
  bank: "Bank",
  bank_purchase: "Kauf lt. Bank",
  document: "Beleg",
  manual: "manuell",
};
